/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { noop } from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { Modal } from '@blend/enterprise-components';
import { ActionButton, Text, BrandColors } from '@blend/enterprise-components';
import { ModalContent } from 'id-components/ModalContent';

import settlementAgentPrivacyPolicy from './1734232234_BlendLabsPrivacyPolicyforSAWLOMobileAgentApp_4.html';
import generalPrivacyPolicy from './1732332389_BlendPlatformConsumerPrivacyPolicy_01_21_25.html';
import settlementAgentPrivacyPolicy2026 from './1767834385_BlendLabsPrivacyPolicyforSAWLOMobileAgentApp_5.html';
import generalPrivacyPolicy2026 from './1767834385_BlendPlatformConsumerPrivacyPolicy_01_07_26.html';

import './privacyPolicy.css';

const styles = StyleSheet.create({
  border: { border: `1px solid ${BrandColors.CLOUD}` },
  center: {
    textAlign: 'center',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  indent: {
    paddingLeft: 16,
  },
  mainTextBody: {
    border: `1px solid ${BrandColors.CLOUD_50}`,
    borderRadius: 4,
    height: 440,
    marginBottom: 16,
    marginTop: 16,
    overflow: 'auto',
    padding: 16,
  },
});

export namespace PrivacyPolicyModal {
  export interface Props {
    handleClose: () => void;
    isOpen: boolean;
  }
}

const NewPrivacyPolicyModal = (id: string, html: string): React.FC<PrivacyPolicyModal.Props> => {
  return ({ isOpen, handleClose }) => {
    return (
      <Modal contentLabel="Privacy Policy" handleClose={noop} isOpen={isOpen} className={id}>
        <ModalContent headerText="Privacy Policy" id={id}>
          <Text>
            <div className={`${css(styles.mainTextBody)} privacy-text`}>
              <div dangerouslySetInnerHTML={{ __html: html }}></div>
            </div>
          </Text>
          <div className={css(styles.footer)}>
            <ActionButton id={`${id}-accept`} label="Done" onClick={handleClose} theme="primary" />
          </div>
        </ModalContent>
      </Modal>
    );
  };
};

export const SettlementAgentPrivacyPolicyModal = NewPrivacyPolicyModal(
  'it-SettlementAgentPrivacyPolicyModal',
  settlementAgentPrivacyPolicy,
);
export const GeneralPrivacyPolicyModal = NewPrivacyPolicyModal('it-GeneralPrivacyPolicyModal', generalPrivacyPolicy);

export const SettlementAgentPrivacyPolicyModal2026 = NewPrivacyPolicyModal(
  'it-SettlementAgentPrivacyPolicyModal2026',
  settlementAgentPrivacyPolicy2026,
);
export const GeneralPrivacyPolicyModal2026 = NewPrivacyPolicyModal(
  'it-GeneralPrivacyPolicyModal2026',
  generalPrivacyPolicy2026,
);
